import script from "./AudienceFooterCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceFooterCount.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceFooterCount.vue?vue&type=style&index=0&id=36ea9ca1&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ea9ca1"]])

export default __exports__